export const moveToFolderNewFolderText = "u9b";
export const moveToArchiveMbxFolderNewFolderText = "v9b";
export const searchFolder = "w9b";
export const searchArchiveFolder = "x9b";
export const moveToSearchSharedFolder = "y9b";
export const moveToFolderCreateNewText = "z9b";
export const moveToArchiveMbxFolderCreateNewText = "A9b";
export const rootFolderString = "B9b";
export default {moveToFolderNewFolderText,moveToArchiveMbxFolderNewFolderText,searchFolder,searchArchiveFolder,moveToSearchSharedFolder,moveToFolderCreateNewText,moveToArchiveMbxFolderCreateNewText,rootFolderString};